module.exports = __webpack_public_path__ + "img/trunk_7x3.47465eaf.svg";